import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InboxOutlined } from "@ant-design/icons";
// Compact "nothing here yet" notice: a dashed box with a muted icon + text.
// Used consistently across the whole customer center (subscriptions, invoices,
// affiliate sections, ...) instead of antd's large default illustration.
const EmptyState = ({ heading, subline })=>/*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-empty",
        children: [
            /*#__PURE__*/ _jsx(InboxOutlined, {
                "aria-hidden": true
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    heading,
                    subline && /*#__PURE__*/ _jsxs("span", {
                        className: "rc-account-v2-empty__subline",
                        children: [
                            " ",
                            subline
                        ]
                    })
                ]
            })
        ]
    });
export { EmptyState };
